/* eslint-disable react/jsx-boolean-value */
import React, { useState, useEffect , useContext } from "react";
import { popupWin } from 'components/PopUps';
import {  UmbracoContext,  UmbracoStep,} from "../../../components/Umbraco/UmbracoContext";
export default function PopUpContact() {

  const resource = UmbracoStep(
    useContext(UmbracoContext).resource,
    "PopUpContact"
  );
  useEffect(() => {  
      let obj = {};
    obj.type = "contactUs";
    obj.resource = resource;
    obj.className = "contactUs";

    popupWin(obj);
  });

  useEffect(() => {
    const script = document.createElement("script");
    script.append(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KZFXLQC');`);
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-KZFXLQC";
    iframe.height = "0";
    iframe.width = "0";
    iframe.style = "display:none;visibility:hidden";
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
  }, []);
  return (
    <></>  );
}
